import React from "react";
import { Color } from "@chesshotel/chess";
import { BRookIcon } from "./pieceIcons/BRookIcon";
import { WRookIcon } from "./pieceIcons/WRookIcon";
import { WBishopIcon } from "./pieceIcons/WBishopIcon";
import { BBishopIcon } from "./pieceIcons/BBishopIcon";
import { BKnightIcon } from "./pieceIcons/BKnightIcon";
import { WKnightIcon } from "./pieceIcons/WKnightIcon";
import { WKingIcon } from "./pieceIcons/WKingIcon";
import { BKingIcon } from "./pieceIcons/BKingIcon";
import { WQueenIcon } from "./pieceIcons/WQueenIcon";
import { BQueenIcon } from "./pieceIcons/BQueenIcon";

// Map piece letter to Staunty SVG file name
const PIECE_SVG_MAP = {
  K: WKingIcon,
  Q: WQueenIcon,
  R: WRookIcon,
  B: WBishopIcon,
  N: WKnightIcon,
  k: BKingIcon,
  q: BQueenIcon,
  r: BRookIcon,
  b: BBishopIcon,
  n: BKnightIcon,
};

// Render the SVG piece symbol for a given piece letter (KQRBN)
export function PieceSymbol({
  piece,
  color,
  outline,
}: {
  piece: string;
  color: Color;
  outline: boolean;
}) {
  piece = color === "b" ? piece.toLowerCase() : piece;

  if (PIECE_SVG_MAP[piece]) {
    const PieceIcon = PIECE_SVG_MAP[piece];
    return (
      <span
        style={{
          display: "inline-block",
          width: "1em",
          height: "1em",
          marginRight: "0.05em",
          verticalAlign: "0em",
        }}
      >
        <PieceIcon
          color={outline ? "#296ea3" : color === "b" ? "#5F5955" : "#3C3C3C"}
        />
      </span>
    );
  }
}

// Helper to render SAN with only the piece symbol as SVG
export function renderSanWithSvg(
  san: string,
  color: Color,
  outline = false,
  lineThrough = false
) {
  if (!san) return san;
  // If SAN starts with a piece letter, replace it with the SVG
  const match = san.match(/^([KQRBN])(.+)/);
  if (match) {
    const piece = match[1];
    const rest = match[2];
    return (
      <span className={"inline-block relative"}>
        {lineThrough && (
          <span
            className={
              "absolute top-1/2 w-full bg-primary -translate-y-1/2 h-[1.5px]"
            }
          ></span>
        )}
        <PieceSymbol piece={piece} color={color} outline={outline} />
        {rest}
      </span>
    );
  }
  // Otherwise, just return the SAN (for pawn moves, etc.)
  return san;
}
